export default __webpack_public_path__ + "static/media/coin.6e37358c.svg";